import type { SVGProps } from "react";
const SvgCursor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 256 256"
    {...props}
  >
    <rect width="100%" height="100%" fill="#fff" />
    <path
      fill="#000"
      d="M123.36 17.223 33.65 68.994a7.84 7.84 0 0 0-3.92 6.776v104.421c0 2.8 1.511 5.367 3.92 6.758l89.683 51.8a9.33 9.33 0 0 0 9.315 0l89.693-51.8a7.84 7.84 0 0 0 3.92-6.758V75.771a7.84 7.84 0 0 0-3.92-6.777l-89.703-51.771a9.43 9.43 0 0 0-9.296 0M40.8 75.154H213.93c2.455 0 4.014 2.68 2.772 4.807l-86.557 149.94c-.578.998-2.137.597-2.137-.56v-98.215a5.51 5.51 0 0 0-2.753-4.76L40.229 77.301c-1.017-.588-.597-2.147.57-2.147"
    />
  </svg>
);
export default SvgCursor;
